// extracted by mini-css-extract-plugin
export default {"category":"category__category___wLJXn"};